export const strings = {
  navbar: {
    project: "Projects",
    explore: "Explore",
  },
  backButton: "Back",
  homePage: {
    welcome: "Welcome to Neb",
    nebula: "la",
    greetings: {
      morning: "Good morning,",
      afternoon: "Good afternoon,",
      evening: "Good evening",
    },
  },
  notmatch: {
    error: "Error 404",
    btn: "Go back home",
  },
  logandsing: {
    create: "Create account",
    login: "Login",
    guest: "Login as guest",
  },
  profile: {
    updateProfile: "Update Profile",
    changePicture: "Change profile picture",
    name: "Name",
    username: "Username",
    emailL: "Email",
    updateBtn: "Update",
    updating: "Updating...",
  },
  sidebar: {
    project: "Project",
    addPage: "Add page",
    delete: "Delete project",
    publish: "Publish project",
    unpublish: "Unpublish project",
  },
  project: {
    createNew: "Create new project",
  },
  explore: {
    gretting: "🌐 Explore new projects",
  },
  starred: {
    gretting: "⭐️ Starred projects",
  },
};
